import { createContext, useContext, useState, useCallback } from "react";

const MentalContext = createContext(null);

export const MentalProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const openMental = useCallback(() => setOpen(true), []);
  const closeMental = useCallback(() => setOpen(false), []);
  return (
    <MentalContext.Provider value={{ open, setOpen, openMental, closeMental }}>
      {children}
    </MentalContext.Provider>
  );
};

export const useMental = () => {
  const ctx = useContext(MentalContext);
  if (!ctx) throw new Error("useMental must be used within MentalProvider");
  return ctx;
};
